import { inject } from '@angular/core';
import type { HttpInterceptorFn } from '@angular/common/http';
import { HttpContextToken, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ForbiddenService } from './forbidden.service';

/**
 * Set on a request whose 403 must NOT take over the page (380363).
 *
 * A 403 used to blank the whole application whatever asked for it, so a dialog refused one
 * incidental read left the user on the access-denied screen after closing it — still entitled to
 * the page they were on, with no way back but to navigate again. Page-level loads keep the old
 * behaviour, which is what the denied screen is for. Incidental reads report their own failure
 * and leave the page alone.
 */
export const SKIP_FORBIDDEN_TAKEOVER = new HttpContextToken<boolean>(() => false);

export const forbiddenInterceptor: HttpInterceptorFn = (req, next) => {
  const forbiddenService = inject(ForbiddenService);
  return next(req).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse && error.status === 403
          && !req.context.get(SKIP_FORBIDDEN_TAKEOVER)) {
        forbiddenService.setForbidden();
      }
      return throwError(() => error);
    })
  );
};
